import { render, staticRenderFns } from "./PlanConfirm.vue?vue&type=template&id=11c70c64&scoped=true&"
import script from "./PlanConfirm.vue?vue&type=script&lang=js&"
export * from "./PlanConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c70c64",
  null
  
)

export default component.exports